<template>
    <div class="SubstationManagement subpostation" >
        <div id="left">
            <div class="Placeholder"></div>
            <div id="areachart"  class="row-center" style=" justify-content: space-between;">
                <div class="EchartsLeft" >
                   <div class="title">电池电量</div>
                    <div class="capacity"><span>配置容量:200KWh</span></div>
                    <div class="tabCharts">
                        <div id="my_echarts" style="height:100%;width:100%"></div>
                    </div>
                </div>
                <div class="EchartsRight statistics">
                    <div class="title">充放电统计</div>
                    <div class="name">近7日充放电量</div>
                    <div class="tabCharts" style="height:21vh">
                        <div id="my_echarts3" style="height:21vh;width:100%"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="rightYuanqu">
            <div class="top">
                <!-- <toggle></toggle> -->
                <div class="title">
                    <img :src="AreaInfo.areaImg" alt="">
                    <div class="titler">
                        <div class="titleName">{{AreaInfo.areaName}}</div>
                        <span @click.prevent.stop="isShowArea = !isShowArea" >切换<img src="../../assets/img/change0.png" alt=""></span>
                        <div v-if="isShowArea" ref="area">
                            <Href @closedArea='closedArea'></Href>
                        </div>
                    </div>
                    <button @click="backYuanqu">返回园区</button>
                </div>
                <div class="motion">自{{startTime}}起，已安全运行 <span>{{projectTime}}</span> 天</div>
                <div class="area row-center">
                    <div class="item">
                        <div class="name">今日充电</div>
                        <div class="num">{{equivalent.todayPowerIn}}kWh</div>
                    </div>
                    <div class="item">
                        <div class="name">今日放电</div>
                        <div class="num">{{equivalent.todayPowerOut}}kWh</div>
                    </div>
                    <div class="item">
                        <div class="name">系统状态</div>
                        <div class="num">正常</div>
                    </div>
                    <div class="item">
                        <div class="name">网关在线</div>
                        <div class="num online"><span>2</span>/2</div>
                    </div>
                </div>
            </div>
            
            <div class="overviewInverter">
                <div class="title">
                   变流器概况
                </div>
                <div class="inverter">
                    <el-dropdown trigger="click" class="dropdown" @command="handleCommand2">
                        <span class="el-dropdown-link">{{transform2}}(开机|正常工作)<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in loopList" :key="index" :command="item">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="looptable">
                    <el-table
                        row-class-name="rowName"
                        header-row-class-name="headerName"
                        height="22vh"
                        border
                        :data="tableData"
                        stripe
                        style="width: 100%">
                        <el-table-column
                        width="120"
                        class-name="name"
                        prop="name"
                        label=""
                        align="center">
                        </el-table-column>
                        <el-table-column
                        prop="val1"
                        align="center"
                        label="A相">
                        </el-table-column>
                        <el-table-column
                        prop="val2"
                        align="center"
                        label="B相">
                        </el-table-column>
                        <el-table-column
                        prop="val2"
                        align="center"
                        label="C相">
                        </el-table-column>
                        <el-table-column
                        prop="total"
                        align="center"
                        label="总">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="EchartsRight statistics">
                <div class="title">经济效益</div>
                <div class="cont row-center">
                    <div class="item">
                        <div class="name">本日节约成本</div>
                        <div class="num">88.94<span>￥</span></div>
                    </div>
                    <div class="item">
                        <div class="name">本月节约成本</div>
                        <div class="num">{{(88.94*new Date().getDate()).toFixed(2)}}<span>￥</span></div>
                    </div>
                    <div class="item">
                        <div class="name">本年节约成本</div>
                        <div class="num">{{(88.94*47).toFixed(2)}}<span>￥</span></div>
                    </div>
                    <div class="item">
                        <div class="name">累计节约成本</div>
                        <div class="num">{{(88.94*47).toFixed(2)}}<span>￥</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Videoone from "./components/videoone";
    import {projectTime } from '../../api/common'
    const Href = ()=>import('./components/href.vue')
    const TodayEvent = ()=>import('./components/newComponts/todayEvent.vue')
    import {
        GET_AREAS,
    } from "../../api/power";
    import {
        getSevenDays,getLastOrNextFewDateBy
    } from "../../util/date";
    import * as echarts from 'echarts';
    export default {
        name: "SubstationManagement",
        data() {
            return {
                transform2:"变流器1",
                echartsData:[120, 200, 150, 80, 70, 110, 130],
                elIdex:0,
                tabBdx:0,
                bianliu:'变流器1',
                isBian:false,
                isShowArea:false,
                tableData: [{
                    name: '电网侧电流(A)',
                    val1: '242.72',
                    val2: '242.75',
                    total:'--'
                }, {
                   name: '电网侧电压(V)',
                    val1: '412.5',
                    val2: '412.3',
                    total:'--'
                }, {
                    name: '直流侧电流(A)',
                    val1: '--',
                    val2: '--',
                    total:'138.8'
                }, {
                   name: '直流侧电压(V)',
                    val1: '--',
                    val2: '--',
                    total:'720'
                }],
                loopList:[
                    {
                        id:1,
                        name:'变流器1'
                    },
                    {
                        id:2,
                        name:'变流器2'
                    }
                ],
                value: '',
                allArea:[],
                AreaInfo:{},
                projectTime:'',
                timeList:[],
                startTime:"" 
                
            };
        },
        watch: {
            '$route.query.id'(n,o){
                this.AreaInfo = this.allArea.filter((e) => e.areaId == n)[0];
            }
        },
        created(){  
            let data =  this.$router.params
        },
        computed:{
            equivalent(){
            let weather = this.$store.state.project.weather
            let hour = new Date().getHours()
            let month = new Date().getMonth() + 1
            let year = new Date().getFullYear()
            let day = new Date().getDate()

            let obj = {
                    equivalent:0 ,        // 等效
                    todayPowerOut:0,      // 放电量
                    todayPowerIn:200,     // 充电量
                    todayPowerSend:200,     // 放电量
                }
            
            
            if(weather == 1 || weather == 2 ){
                // 等效小时
                obj.equivalent = 4.5  

                // 计算发电量
                let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
                obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))

            }else{
                obj.equivalent = 8

                // 计算发电量
                let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
                obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))
            }

            let timeC = new Date().getTime()
            let timeA = new Date(`${year}-${month}-${day} 20:00:00`).getTime()
            let timeB = new Date(`${year}-${month}-${day} 17:00:00`).getTime()

            // 8点到10点放电电量 
            if(hour >= 20 && hour<= 22){
                let timeP = (timeC - timeA) / 1000 / 7200 * 200
                obj.todayPowerOut = timeP.toFixed(2)
            }else{
                obj.todayPowerOut = 0
            }

            // 0点到4点充电电量
            if(hour >= 0 && hour<= 4){
                let timeP = (timeC - timeB) / 1000 / 3600 * 400 * 200
                obj.todayPowerIn = timeP.toFixed(2)
            }else{
                obj.todayPowerIn = 160
            }

            return obj
        },
        },
        mounted() {
            this.$store.commit("Dthere", 4);
        
            let d = new Date(this.$store.state.project.projectInfo.deploymentTime)
            this.startTime = d.getFullYear() + "年"+ (d.getMonth() + 1) +"月"+ d.getDate() +"日";
            this.echartsInit()
            this.getProjectTime()
            this.energyCharts("my_echarts3")
            document.addEventListener('click', this.closePopover);
            GET_AREAS().then(res => {
                this.allArea = res.data.data.areas;
                this.AreaInfo = this.allArea.filter((e) => e.areaId == this.$route.query.id)[0];
            })
        },
        beforeDestroy() {
             document.removeEventListener("click", this.closePopover);
        },
        components: {
            Videoone,Href,TodayEvent
        },
        methods: {
            async getProjectTime(){
                let res = await projectTime()
                this.projectTime = res.data.data.day
            },
            getDistanceSpecifiedTime(dateTime) {
                var EndTime = new Date(dateTime);
                var NowTime = new Date();
                var t = NowTime.getTime() - EndTime.getTime();
                var d = Math.floor(t / 1000 / 60 / 60 / 24);
                return d;
            },
            closePopover(e){
                let self = this;
                if (self.$refs.area && !self.$refs.area.contains(e.target)) {
                    if (self.isShowArea == true){
                        self.isShowArea = false
                    }
                }
            },
            handleCommand2(command) {
                 this.transform2 = command.name
            },
            changeTab(index,tag){
                if(tag == 'B'){
                    this.tabBdx = index
                    this.isBian= false
                }else if(tag == 'E'){
                    this.elIdex = index
                }else{ 
                    this.tabSdx = index
                }
            },
            closedArea(){
                this.isShowArea = false
            },
             energyCharts(val){
                let data = this.echartsData
                var chartDom = document.getElementById(val);
                var myChart = echarts.init(chartDom);
                let xData = getLastOrNextFewDateBy(new Date())
                myChart.setOption({
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value',
                        name:'kWh'
                    },
                    series: [{
                        name:"充电量",
                        data:[0, 160, 160, 160, 160, 160, 160] ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5B8FF9',
                            barBorderRadius:[7,7,0,0]
                        }
                    },{
                        name:"放电量",
                        data:[0, 160, 160, 160, 160, 160, 0] ,
                        type: 'bar',
                        barWidth:15,
                        itemStyle:{
                            color:'#5AD8A6',
                            barBorderRadius:[7,7,0,0]
                        }
                    }],
                    grid: {
                        left: "0%",
                        right: "0%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                    
                    tooltip: {
                        trigger: 'axis'
                    },
                })
            },
            echartsInit(){
                var chartDom = document.getElementById('my_echarts');
                var myChart = echarts.init(chartDom);
                let temp = []
                for (let i = 0; i <= 24; i++) {
					temp.push(i + "点")
				}
                let arr = [40, 80, 120, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 120, 40, 40, 40 ]
                let hour = new Date().getHours() + 1
                let seriesData = arr.splice(0,hour)
                myChart.setOption({
                    grid: {
                        left: "0%",
                        right: "3%",
                        bottom: "4%",
                        top: "15%",
                        containLabel: true,
                    },
                   
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:temp
                    },
                    yAxis: {
                        type: 'value',
                        name:"剩余电量",
                        nameTextStyle:{
                            padding: [0,0 ,0,24],
                            fontSize:"16rem",  
                            color:"#333"
                        }
                    },
                    series: [
                        {
                            name: '今日',
                            data:  seriesData,
                            type: 'line',
                            smooth: true,
                            itemStyle: {
                                color: '#0D94FF'
                            },
                            areaStyle: {
                                color:{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: 'rgba(58,132,255, 0.4)' // 0% 处的颜色
                                    }, {
                                        offset: 1, color: 'rgba(58,132,255, 0)' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                }
                            }
                        },
                       
                    ]
                })
            },
            //选择变流器
            showBianliu(){
                this.isBian = true
            },
            backYuanqu(){
                this.$router.push('SubstationManagement')
                this.$store.commit("Dthere", 1);
                this.$store.commit("webId", null);

            }
        },
    };
</script>
<style scoped lang="less">
.subpostation{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.dropdown.el-dropdown{
    font-size: 18rem !important;
    color: #333;
	cursor: pointer;
    padding: 0 10rem;
}
/deep/.headerName{
    th{
        // background: rgba(0, 43, 102, 0.03);
        border-bottom: 0;
        font-size: 16rem;
        color: #333;
        font-weight: 400;
        height: 4vh;
        padding: 0;
    }
}
/deep/.rowName{
    td{
        border-bottom: 0;
        font-size: 16rem;
        color: #0D94FF;
        font-weight: 400;
        height: 4vh;
        background: none !important;
        padding: 0;
    }
    .name{
        color: #333;

    }
    td:nth-child(even){
        background: rgba(0, 43, 102, 0.03) !important;
    }
}
/deep/.headerName {
    background-color: rgba(0, 43, 102, 0.03) !important;
    th{
        background: none;
    }
    th:nth-child(even){
        background: rgba(0, 43, 102, 0.03) !important;
    }
}
/deep/.el-table__row--striped.rowName{
    background: rgba(0, 43, 102, 0.03);
}
/deep/.el-table--border::after, /deep/.el-table--group::after, /deep/.el-table::before{
    content: none;
}
/deep/.el-table--border,/deep/ .el-table--group{
    border: 0;
}
.Placeholder{
    z-index: -1;
}
.looptable{
    
    table{
        width: 100%;
        td{
            height: 60rem;
            text-align: center;
            font-size: 16rem;
            width: 20%;
        }
        tr:nth-child(odd){
            background: rgba(0, 43, 102, 0.03);
        }
        tr td:nth-child(even){

            background: rgba(0, 43, 102, 0.03);
        }
        .name{
            color: #0D94FF;
        }
    }
}
.statistics{
    height: 29.62962963vh !important;
    .name{
        text-align: center;
        font-size: 18rem;
    }
    .cont{
        justify-content: space-between;
        .item{
            background: rgba(0, 43, 102, 0.03);
            width: 49.2%;
            height: 11vh;
            text-align: center;
            margin-bottom: 8rem;
            .name{
                font-size: 18rem;
                margin-top: 3vh;
            }
            .num{
                font-size: 30rem;
                font-weight: bold;
                color: #0D94FF;
            }
            span{
                font-size: 20rem;
                margin-left: 3rem
            }
        }
    }
}
.EchartsLeft,.EchartsRight{
    .w(528);
    background: #ffffff;
    height: 100%;
    padding:20rem 23rem;
    position: relative;
    .capacity{
        color: #999999;
        font-size: 18rem;
        overflow: hidden;
        clear: both;
        position: absolute;
        top: 50rem;
        right: 20px;
    }
    .title{
        font-size: 18rem;
        font-weight: bold;
        margin-bottom: 10rem;
    }
}
    .motion{
        font-size: 18rem;
        text-align: center;
        height: 6vh;
        line-height: 6vh;
        background: rgba(0, 43, 102, 0.04);
        border-radius: 8rem;
        margin-bottom: 33rem;
        span{
            color: #0D94FF;
            font-size: 30rem;
            font-weight: bold;
            vertical-align: -4px;
        }
    }
    .area{
        justify-content: space-between;
        .item{
            // width: 25%;
            text-align: center;
            .name{
                font-size: 18rem;
                height: 30px;
            }
            .num{
                color: #0D94FF;
                font-size: 20rem;
                font-weight: bold;
            }
            
            .online{
                color: #333;
                span{
                    color: #68D86A;
                }
            }
        }
    }
    
</style>